import { legacyParse } from '@date-fns/upgrade/v2'
import { differenceInCalendarDays, startOfToday } from 'date-fns'
import { SupplementedUserSubscription } from '../../account-settings.interfaces'
import { MinimalSubscription } from '../../../shared/subscriptions/subscriptions.interface'
import { SiteIds } from '../../../shared/models/site.model'
import { StripeSubscriptionStatus } from '@flocasts/payments'

export const shouldShowDowngrade = (
  hasParam: boolean,
  annualPlan: boolean,
  hasDowngraded = false,
  discountAppliedAlready = false,
  createdAt?: Date | string
): boolean => {
  if (!createdAt) return false

  const subscriptionCreatedWithin30Days = differenceInCalendarDays(legacyParse(createdAt), startOfToday()) >= -30

  return hasParam && subscriptionCreatedWithin30Days && annualPlan && !hasDowngraded && !discountAppliedAlready
}

export const supplementWithPriceDetails = (subscription: SupplementedUserSubscription) => {
  const monthlyDollars: string = subscription.upcoming_price_monthly
    ? subscription.upcoming_price_monthly.localized_text
    : subscription &&
      subscription.plan &&
      subscription.plan.cost_per_month &&
      subscription.plan.cost_per_month.localized_text

  const yearlyAmount: string =
    subscription && subscription.plan && subscription.plan.price && subscription.plan.price.localized_text
  const yearlyDollars = subscription.upcoming_price_money
    ? subscription.upcoming_price_money.localized_text
    : yearlyAmount

  return {
    ...subscription,
    monthlyDollars,
    yearlyDollars,
    periodText: subscription.plan_is_yearly ? 'Yearly' : 'Monthly',
    explanation: `${monthlyDollars}/mo is the monthly average billed at ${yearlyDollars}/yr.`
  }
}

export const buildModalDisclaimer = (monthlyPlanCost: string): string => {
  return `By switching you will be refunded the current difference between subscriptions and charged ${monthlyPlanCost} each month (plus tax) moving forward.`
}

export function canUpgrade(subscription: MinimalSubscription): boolean {
  if (subscription && subscription.plan) {
    return subscription.plan.period !== 'year' && (subscription.is_active ?? false)
  }
  return false
}

export function canCancelSubscription(status: string): boolean {
  return status === StripeSubscriptionStatus.Active || status === StripeSubscriptionStatus.Trial
}

export function subscriptionIsFromNewArchitecture(id: number | string): boolean {
  return typeof id === 'string'
}
